import React, { useState, useEffect } from 'react'
import InterestTable from './InterestTable'
import PricingPlans from './PricingPlans/PricingPlans'
import AwardBadges from '../common/components/AwardBadges'
import TrustPilot from '../common/components/TrustPilot'
import HubspotContactForm from '../common/components/HubspotContactForm'
import PartnersCTA from '../common/components/PartnersCTA'
// import AllInterestRates from './AllInterestRates'
import FAQ from '../common/components/FAQ'
import { Link } from 'react-scroll'
import CollapseButton from '../../components/CollapseButton';


function App() {

  return(
    <div>
      <PricingPlans />
      <AwardBadges header={<h3 className='text-center mt-4 mb-5 mr-1 ml-1'>We're an award winning lender!</h3>} />
      {/* <AllInterestRates /> */}
      <FAQ />
      <HubspotContactForm />
      <TrustPilot templateId='53aa8912dec7e10d38f59f36' height="140px"/>
      <PartnersCTA />
    </div>
  )
}

export default App
